import { Skeleton } from "@mui/material";

/**
 * Row-style skeleton — for tables and stacked list content.
 *
 * Previously each row was wrapped in <Typography variant="h1">, which meant
 * a loading table rendered five real <h1> elements on the page (bad for
 * accessibility and SEO), with a hardcoded row count/height that couldn't
 * be reused anywhere the shape didn't happen to match.
 */
export const TableLoader = ({ rows = 5, height = 75 }) => {
    return (
        <div role="status" aria-busy="true" aria-label="Loading" style={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '100%' }}>
            {Array.from({ length: rows }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="rounded"
                    animation="wave"
                    height={height}
                    width="100%"
                    sx={{ borderRadius: '8px' }}
                />
            ))}
        </div>
    );
};

/**
 * Card-grid skeleton — for pricing/plan cards and similar grid layouts.
 * Mirrors the actual card shape (badge space, title, price, feature list,
 * button) instead of generic bars, so the page doesn't visually jump once
 * real content arrives.
 */
export const SubscribeLoader = ({ cards = 3, featureRows = 4 }) => {
    return (
        <div
            role="status"
            aria-busy="true"
            aria-label="Loading"
            style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '24px', width: '100%' }}
        >
            {Array.from({ length: cards }).map((_, i) => (
                <div
                    key={i}
                    style={{
                        flex: '1 1 260px',
                        maxWidth: '320px',
                        padding: '25px 30px',
                        borderRadius: '16px',
                        background: '#fff',
                        boxShadow: 'rgba(100, 100, 111, 0.15) 0px 7px 29px 0px',
                    }}
                >
                    <Skeleton variant="text" animation="wave" width="50%" height={32} />
                    <Skeleton variant="text" animation="wave" width="80%" height={22} sx={{ mb: 1 }} />
                    <Skeleton variant="text" animation="wave" width="60%" height={48} sx={{ mb: 2 }} />
                    {Array.from({ length: featureRows }).map((_, j) => (
                        <Skeleton key={j} variant="text" animation="wave" width="90%" height={26} />
                    ))}
                    <Skeleton variant="rounded" animation="wave" height={44} width="100%" sx={{ borderRadius: '8px', mt: 2 }} />
                </div>
            ))}
        </div>
    );
};